import React from 'react';
import { Icons } from '@codev/helix-react';
const InfoCircle = Icons.InfoCircle;

export default (key, lang) => {
  let mapping = {
    title: {
      en_US: 'Choose Your Multi-Factor Authentication Method',
      de_DE: 'Wählen Sie Ihre Multi-Faktor-Authentifizierungsmethode',
      el_GR: 'Επιλέξτε τη μέθοδο επαλήθευσης πολλαπλών παραγόντων',
      es_ES: 'Elija su Método de Autenticación Multifactor',
      fr_FR: "Choisissez votre méthode d'authentification multifacteur",
      fr_CA: "Choisissez votre méthode d'authentification multifacteur",
      it_IT: 'Scegli il tuo metodo di autenticazione a più fattori',
      pl_PL: 'Wybierz metodę uwierzytelniania wieloskładnikowego',
      th_TH: 'เลือกวิธีการรับรองความถูกต้องแบบหลายปัจจัย',
      zh_CN: '选择您的多重身份验证方法',
      pt_BR: 'Escolha seu método de autenticação multifator',
      ja_JP: '多要素認証方法を選択してください',
    },
    titleForRecovery: {
      en_US: <>Choose Your Password Recovery Method</>,
      de_DE: <>Wählen Sie Ihre Passwort-Wiederherstellungsmethode</>,
      el_GR: <>Επιλέξτε τη μέθοδο ανάκτησης κωδικού πρόσβασης</>,
      es_ES: <>Elija su método de recuperación de contraseña</>,
      fr_FR: <>Choisissez votre méthode de récupération de mot de passe.</>,
      fr_CA: <>Choisissez votre méthode de récupération de mot de passe.</>,
      it_IT: <>Scegli il tuo metodo di recupero della password</>,
      pl_PL: <>Wybierz metodę odzyskiwania hasła</>,
      th_TH: <>เลือกวิธีการกู้คืนรหัสผ่านของคุณ</>,
      zh_CN: <>選擇密碼復原方法</>,
      pt_BR: <>Escolha seu método de recuperação de senhas</>,
      ja_JP: <>パスワードの回復方法の選択</>,
    },
    submitText: {
      en_US: 'Continue',
      de_DE: 'Fortsetzen',
      el_GR: 'Να συνεχίσει',
      es_ES: 'Seguir',
      fr_FR: 'Continuer',
      fr_CA: 'Continuer',
      it_IT: 'Continua',
      pl_PL: 'Kontyntynuj',
      th_TH: 'ต่อ',
      zh_CN: '继续',
      pt_BR: 'Continuar',
      ja_JP: '継続する',
    },
    cancelText: {
      en_US: 'Skip for now',
      de_DE: 'Vorerst überspringen',
      el_GR: 'Παράλειψη προς το παρόν',
      es_ES: 'Salta por ahora',
      fr_FR: 'Sauter pour l’instant',
      fr_CA: 'Sauter pour l’instant',
      it_IT: 'Salta per ora',
      pl_PL: 'Pomiń na razie',
      th_TH: 'ข้ามไปเดี๋ยวนี้',
      zh_CN: '請現在跳過',
      pt_BR: 'Pule por enquanto',
      ja_JP: '今のところスキップ',
    },
    stepText: {
      en_US: 'Please choose one of the following forms of multi-factor authentication.',
      de_DE: 'Wählen Sie eine der folgenden Formen der mehrstufigen Authentifizierung aus.',
      el_GR: 'Επιλέξτε μία από τις ακόλουθες μορφές ελέγχου ταυτότητας πολλών παραγόντων.',
      es_ES: 'Elija una de las siguientes formas de autenticación multifactor.',
      fr_FR: "Veuillez choisir l’une des formes suivantes d’authentification multifacteur.",
      fr_CA: "Veuillez choisir l’une des formes suivantes d’authentification multifacteur.",
      it_IT: 'Scegliere una delle seguenti forme di autenticazione a più fattori.',
      pl_PL: 'Wybierz jedną z następujących form uwierzytelniania wieloskładnikowego.',
      th_TH: 'โปรดเลือกหนึ่งในรูปแบบต่อไปนี้ของการรับรองความถูกต้องหลายปัจจัย',
      zh_CN: '請選擇以下形式的多重身份驗證之一。',
      pt_BR: 'Por favor, escolha uma das seguintes formas de autenticação multifatorial.',
      ja_JP: '多要素認証の次の形式のいずれかを選択してください。',
    },
    stepTextForRecovery: {
      en_US: <>We'll use this to send you a verification code if you ever forget your password.</>,
      de_DE: <>Wir verwenden dies, um Ihnen einen Bestätigungscode zu senden, wenn Sie Jemals Ihr Passwort vergessen haben.</>,
      el_GR: <>Θα χρησιμοποιήσουμε αυτό για να σας στείλουμε έναν κωδικό επαλήθευσης αν ξεχάσετε ποτέ τον κωδικό πρόσβασής σας.</>,
      es_ES: <>Usaremos esto para enviarle un código de verificación si alguna vez olvida su contraseña.</>,
      fr_FR: <>Nous l’utiliserons pour vous envoyer un code de vérification si jamais vous oubliez votre mot de passe.</>,
      fr_CA: <>Nous l’utiliserons pour vous envoyer un code de vérification si jamais vous oubliez votre mot de passe.</>,
      it_IT: <>Useremo questo per inviarti un codice di verifica se dimentichi la password.</>,
      pl_PL: <>Użyjemy tego, aby wysłać Ci kod weryfikacyjny, jeśli kiedykolwiek zapomnisz hasła.</>,
      th_TH: <>เราจะใช้วิธีนี้เพื่อส่งรหัสยืนยันให้คุณหากคุณลืมรหัสผ่าน</>,
      zh_CN: <>如果您忘記了密碼,我們將用它來向您發送驗證碼。</>,
      pt_BR: <>Usaremos isso para enviar um código de verificação se você esquecer sua senha.</>,
      ja_JP: <>パスワードを忘れた場合は、これを使用して確認コードを送信します。</>,
    },
    authMethodRequiredMessage: {
      en_US: 'Authentication method is required',
      de_DE: 'Authentifizierungsmethode ist erforderlich',
      el_GR: 'Απαιτείται μέθοδος ελέγχου ταυτότητας',
      es_ES: 'Se requiere un método de autenticación.',
      fr_FR: "Une méthode d'authentification est requise",
      fr_CA: "Une méthode d'authentification est requise",
      it_IT: 'È richiesto il metodo di autenticazione',
      pl_PL: 'Wymagana jest metoda uwierzytelnienia',
      th_TH: 'ต้องใช้วิธีการรับรองความถูกต้อง',
      zh_CN: '需要身份验证方法',
      pt_BR: 'É necessário um método de autenticação',
      ja_JP: '認証方法が必要です',
    },
    panel1Description: {
      en_US: 'We\'ll send a code in a text message to your phone',
      de_DE: 'Wir senden einen Code in einer Textnachricht an Ihr Telefon',
      el_GR: 'Θα στείλουμε ένα κωδικό σε ένα μήνυμα κειμένου στο τηλέφωνό σας',
      es_ES: 'Le enviaremos un código en un mensaje de texto a su teléfono.',
      fr_FR: 'Nous enverrons un code dans un message texte à votre téléphone',
      fr_CA: 'Nous enverrons un code dans un message texte à votre téléphone',
      it_IT: 'Invieremo un codice in un messaggio di testo al tuo telefono',
      pl_PL: 'Wyślemy Ci kod w wiadomości tekstowej na Twój telefon',
      th_TH: 'เราจะส่งรหัสในข้อความไปยังโทรศัพท์ของคุณ',
      zh_CN: '我们会将短信中的验证码发送到您的手机',
      pt_BR: 'Enviaremos um código em uma mensagem de texto para o seu telefone',
      ja_JP: 'テキストメッセージのコードを電話に送信します',
    },
    panel1MethodName: {
      en_US: 'Get A Text Message',
      de_DE: 'Holen Sie sich eine SMS',
      el_GR: 'Αποκτήστε ένα μήνυμα κειμένου',
      es_ES: 'Recibe un Mensaje de Texto',
      fr_FR: 'Obtenez un message texte',
      fr_CA: 'Obtenez un message texte',
      it_IT: 'Ricevi un messaggio di testo',
      pl_PL: 'Uzyskaj wiadomość tekstową',
      th_TH: 'รับข้อความ',
      zh_CN: '收到短信',
      pt_BR: 'Obter uma mensagem de texto',
      ja_JP: 'テキストメッセージを取得する',
    },
    panel1Tooltip: {
      en_US: 'Standard SMS rates may apply.',
      de_DE: 'Möglicherweise gelten Standard-SMS-Tarife.',
      el_GR: 'Μπορεί να ισχύουν σταθεροί ρυθμοί SMS.',
      es_ES: 'Se pueden aplicar tarifas estándar por SMS.',
      fr_FR: "Des tarifs SMS standard peuvent s'appliquer.",
      fr_CA: "Des tarifs SMS standard peuvent s'appliquer.",
      it_IT: 'Potrebbero essere applicate tariffe SMS standard.',
      pl_PL: 'Mogą obowiązywać standardowe stawki SMS.',
      th_TH: 'อาจมีค่าบริการ SMS มาตรฐาน',
      zh_CN: '标准短信价格可能适用。',
      pt_BR: 'Taxas padrão de SMS podem ser aplicadas.',
      ja_JP: '標準のSMS料金が適用される場合があります。',
    },
    panel1TooltipLink: {
      en_US: '($)',
      de_DE: '(€)',
      el_GR: '(€)',
      es_ES: '($)',
      fr_FR: '(€)',
      fr_CA: '($)',
      it_IT: '(€)',
      pl_PL: '(zł)',
      th_TH: '(฿)',
      zh_CN: '(¥)',
      pt_BR: '($)',
      ja_JP: '(¥)',
    },
    panel2Description: {
      en_US: 'Get a code on any device from an app',
      de_DE: 'Holen Sie sich einen Code auf einem beliebigen Gerät von einer App',
      el_GR: 'Λάβετε έναν κώδικα σε οποιαδήποτε συσκευή από μια εφαρμογή',
      es_ES: 'Obtenga un código en cualquier dispositivo desde una aplicación',
      fr_FR: "Obtenez un code sur n'importe quel appareil à partir d'une application",
      fr_CA: "Obtenez un code sur n'importe quel appareil à partir d'une application",
      it_IT: "Ottieni un codice su qualsiasi dispositivo da un'app",
      pl_PL: 'Uzyskaj kod na dowolnym urządzeniu z aplikacji',
      th_TH: 'รับรหัสในอุปกรณ์ใด ๆ จากแอป',
      zh_CN: '通过应用在任何设备上获取代码',
      pt_BR: 'Obtenha um código em qualquer dispositivo de um aplicativo',
      ja_JP: 'アプリから任意のデバイスでコードを取得する',
    },
    panel2MethodName: {
      en_US: 'Use an Authenticator',
      de_DE: 'Verwenden Sie einen Authenticator',
      el_GR: 'Χρησιμοποιήστε έναν Επαληθευτή',
      es_ES: 'Use un Autenticador',
      fr_FR: 'Utilisez un Authentificateur',
      fr_CA: 'Utilisez un Authentificateur',
      it_IT: 'Usa un Autenticatore',
      pl_PL: 'Użyj Authenticatora',
      th_TH: 'ใช้ Authenticator',
      zh_CN: '使用身份验证器',
      pt_BR: 'Use um Autenticador',
      ja_JP: '認証システムを使用する',
    },
    panel2Tooltip: {
      en_US:
    <>
      <p>You will use an app to generate a code from your computer, tablet or phone. Authenticators are more secure, no SMS or data fees are incurred, and it works globally, even offline, wherever you are.</p>
      <p>We'll show you how to set it up on the next screen.</p>
    </>,
      de_DE:
    <>
      <p>Sie verwenden eine App, um einen Code von Ihrem Computer, Tablet oder Telefon zu generieren. Authentifikatoren sind sicherer, es fallen keine SMS- oder Datengebühren an und sie funktionieren global, auch offline, wo immer Sie sind.</p>
      <p>Wir zeigen Ihnen auf dem nächsten Bildschirm, wie Sie es einrichten.</p>
    </>,
      el_GR:
    <>
      <p>Θα χρησιμοποιήσετε μια εφαρμογή για να δημιουργήσετε έναν κώδικα από τον υπολογιστή, το tablet ή το τηλέφωνό σας. Οι επαληθευτές είναι πιο ασφαλείς, δεν εισπράττονται SMS ή τέλη δεδομένων και λειτουργεί παγκοσμίως, ακόμη και εκτός σύνδεσης, όπου κι αν βρίσκεστε.</p>
      <p>Θα σας δείξουμε πώς να το ορίσετε στην επόμενη οθόνη.</p>
    </>,
      es_ES:
    <>
      <p>Utilizará una aplicación para generar un código desde su computadora, tableta o teléfono. Los autenticadores son más seguros, no se incurre en tarifas por SMS o datos, y funciona globalmente, incluso sin conexión, donde sea que se encuentre.</p>
      <p>Le mostraremos cómo configurarlo en la siguiente pantalla.</p>
    </>,
      fr_FR:
    <>
      <p>Vous utiliserez une application pour générer un code à partir de votre ordinateur, tablette ou téléphone. Les authentificateurs sont plus sécurisés, aucuns frais de SMS ou de données ne sont engagés et cela fonctionne à l'échelle mondiale, même hors ligne, où que vous soyez.</p>
      <p>Nous vous montrerons comment le configurer sur l'écran suivant.</p>
    </>,
      fr_CA:
    <>
      <p>Vous utiliserez une application pour générer un code à partir de votre ordinateur, tablette ou téléphone. Les authentificateurs sont plus sécurisés, aucuns frais de SMS ou de données ne sont engagés et cela fonctionne à l'échelle mondiale, même hors ligne, où que vous soyez.</p>
      <p>Nous vous montrerons comment le configurer sur l'écran suivant.</p>
    </>,
      it_IT:
    <>
      <p>Utilizzerai un'app per generare un codice dal tuo computer, tablet o telefono. Gli autenticatori sono più sicuri, non sono previsti costi SMS o dati e funzionano a livello globale, anche offline, ovunque tu sia.</p>
      <p>Ti mostreremo come impostarlo nella schermata successiva.</p>
    </>,
      pl_PL:
    <>
      <p>Użyjesz aplikacji do wygenerowania kodu z komputera, tabletu lub telefonu. Urządzenia uwierzytelniające są bezpieczniejsze, nie są ponoszone żadne opłaty za SMS-y ani przesyłanie danych, i działa globalnie, nawet offline, gdziekolwiek jesteś.</p>
      <p>Pokażemy Ci, jak to ustawić na następnym ekranie.</p>
    </>,
      th_TH:
    <>
      <p>คุณจะใช้แอพเพื่อสร้างรหัสจากคอมพิวเตอร์แท็บเล็ตหรือโทรศัพท์ authenticators จะปลอดภัยมากขึ้นไม่มีค่า SMS หรือข้อมูลเกิดขึ้นและทำงานได้ทั่วโลกแม้แต่ออฟไลน์ไม่ว่าคุณจะอยู่ที่ไหน</p>
      <p>เราจะแสดงวิธีการตั้งค่าในหน้าจอถัดไป</p>
    </>,
      zh_CN:
    <>
      <p>您将使用一个应用程序从您的计算机，平板电脑或手机生成代码。身份验证器更安全，不会产生SMS或数据费用，并且无论您身在何处，它都可在全球范围内甚至离线运行。</p>
      <p>我们将在下一个屏幕上向您展示如何进行设置。</p>
    </>,
      pt_BR:
    <>
      <p>Você usará um aplicativo para gerar um código do seu computador, tablet ou telefone. Os autenticadores são mais seguros, não são cobradas taxas de SMS ou de dados e funcionam globalmente, mesmo offline, onde quer que você esteja.</p>
      <p>Mostraremos como configurá-lo na próxima tela.</p>
    </>,
      ja_JP:
    <>
      <p>アプリを使用して、コンピューター、タブレット、または電話からコードを生成します。認証システムはより安全で、SMSやデータ料金は発生しません。また、どこにいてもオフラインでもグローバルに機能します。</p>
      <p>次の画面で設定方法を示します。</p>
    </>,
    },
    panel2TooltipLink: {
      en_US: <InfoCircle style={{fill: "#0C7C84"}} />,
      de_DE: <InfoCircle style={{fill: "#0C7C84"}} />,
      el_GR: <InfoCircle style={{fill: "#0C7C84"}} />,
      es_ES: <InfoCircle style={{fill: "#0C7C84"}} />,
      fr_FR: <InfoCircle style={{fill: "#0C7C84"}} />,
      fr_CA: <InfoCircle style={{fill: "#0C7C84"}} />,
      it_IT: <InfoCircle style={{fill: "#0C7C84"}} />,
      pl_PL: <InfoCircle style={{fill: "#0C7C84"}} />,
      th_TH: <InfoCircle style={{fill: "#0C7C84"}} />,
      zh_CN: <InfoCircle style={{fill: "#0C7C84"}} />,
      pt_BR: <InfoCircle style={{fill: "#0C7C84"}} />,
      ja_JP: <InfoCircle style={{fill: "#0C7C84"}} />,
    },
  };
  return mapping[key][lang];
};